import { faMountain } from '@fortawesome/pro-solid-svg-icons'
import { DateTime } from 'luxon'

import { SeriesTag } from '@/client/services/tags/types'

export const SUMMER_CAMP_SERIES_TAG = SeriesTag.SummerCamp2025
export const SUMMER_CAMP_FEATURED_SERIES_TAG = SeriesTag.SummerCamp2025Featured

export const SUMMER_CAMP_LAUNCH_DATE = DateTime.local(2025, 6, 26)
export const SUMMER_CAMP_START_DATE = DateTime.local(2025, 7, 1, 0, 0, {
  zone: 'America/New_York',
})
export const SUMMER_CAMP_END_DATE = DateTime.local(2025, 8, 31, 23, 59, {
  zone: 'America/New_York',
})
export const SUMMER_CAMP_YEAR = SUMMER_CAMP_START_DATE.get('year')

export const SUMMER_CAMP_COLORS = {
  darkColor: 'primary.fg',
  primaryColor: 'primary.solid',
  lightColor: 'primary.muted',
  contrastColor: 'neutrals.solid',
}

export const SUMMER_CAMP_HERO_LOGO_SRC = '/summer-camp/logo-2025-v2.png'
export const SUMMER_CAMP_HERO_BG_SRC = '/summer-camp/hero-bg-2025.png'
export const SUMMER_CAMP_ILLUSTRATION_SRC = '/summer-camp/map-illustration-2025.png'
export const SUMMER_CAMP_ALERT_LEFT_SRC = '/summer-camp/small-mountain-logo.png'
export const SUMMER_CAMP_ICON = faMountain
